import $ from 'jQuery';
// import vars from '../../../../vars.js';
import Jakte from '@drawbotics/jakte-core';

// DOM elements
let form;
let sendButton;
let success;

// Logic
/// Acquires DOM elements, chooses an agency, and attaches the submit form handler to the submit event.
function init() {
  sendButton = $('.Contact--send');
  success = $('.Contact--success');

  form = $('.js-form-submit');
  if (form[0]) {
    form.on('submit', () => handleSubmitForm());
  }
}

// function gtag_report_conversion(url) {
//   const callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
//   };
//   gtag('event', 'conversion', {
//       'send_to': 'AW-567500731/NCUUCNrYwuEBELu_zY4C',
//       'event_callback': callback
//   });
//   return false;
// }

/// Creates the email message from the form fields and sends the email.
function handleSubmitForm() {
  const name    = form[0]['firstname'].value;
  const surname = form[0]['lastname'].value;
  const email   = form[0]['email'].value;
  const message = form[0]['message'].value;
  const minimumSurface = $('.js-range-slider').data('from');
  const maximumSurface = $('.js-range-slider').data('to');

  const data = {
    firstName: name,
    lastName: surname,
    email,
    minimumSurface,
    maximumSurface,
    message,
  };

  Jakte.plugins.leads.captureLead(data).then(_requestSuccess);
}

/// Resets the contact form and toggles the "Send" button after the contact email was sent successfully.
function _requestSuccess() {
  sendButton.hide(0);
  success.show(0);
  form[0].reset();
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js